import React, { useState, useEffect, useCallback } from 'react';
import { api } from './api';

const fmt = v => parseFloat(v||0).toLocaleString('pt-BR',{style:'currency',currency:'BRL'});

const openWpp = (phone) => {
  if (!phone) return alert('Cliente sem telefone cadastrado');
  const num = phone.replace(/\D/g, '');
  const full = num.length <= 11 ? '55' + num : num;
  window.open('https://wa.me/' + full, '_blank');
};

export default function PreVenda() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = user.perfil === 'Admin';
  const [summary, setSummary] = useState(null);
  const [products, setProducts] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [tab, setTab] = useState(isAdmin ? 'resumo' : 'reservas');
  const [loading, setLoading] = useState(true);

  const [showProdForm, setShowProdForm] = useState(false);
  const [editProd, setEditProd] = useState(null);
  const [prodForm, setProdForm] = useState({ name:'', price:'', total_qty:'' });

  const [showResForm, setShowResForm] = useState(false);
  const [editRes, setEditRes] = useState(null);
  const [resClient, setResClient] = useState({ client_name:'', client_phone:'', payment_status:'Pendente', paid_amount:'', notes:'' });
  const [resItems, setResItems] = useState([{ presale_product_id:'', qty:'1' }]);

  const [filterProduct, setFilterProduct] = useState('');
  const [filterStatus, setFilterStatus] = useState('');

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const s = await api.presaleSummary();
      if (s) { setSummary(s); setProducts(s.products||[]); setReservations(s.reservations||[]); }
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  // Product CRUD
  const openNewProd = () => { setEditProd(null); setProdForm({name:'',price:'',total_qty:''}); setShowProdForm(true); };
  const openEditProd = (p) => { setEditProd(p); setProdForm({name:p.name,price:String(p.price),total_qty:String(p.total_qty)}); setShowProdForm(true); };
  const saveProd = async () => {
    const data = {name:prodForm.name,price:parseFloat(prodForm.price),total_qty:parseInt(prodForm.total_qty)};
    if (!data.name||!data.price||!data.total_qty) return alert('Preencha todos os campos');
    try { if(editProd) await api.updatePresaleProduct(editProd.id,data); else await api.createPresaleProduct(data); setShowProdForm(false); load(); } catch(e){alert(e.message);}
  };
  const delProd = async(id)=>{ if(!window.confirm('Remover este produto?')) return; await api.deletePresaleProduct(id); load(); };

  // Reservation CRUD
  const openNewRes = (productId) => {
    setEditRes(null);
    setResClient({client_name:'',client_phone:'',payment_status:'Pendente',paid_amount:'',notes:''});
    setResItems([{presale_product_id:productId?String(productId):'',qty:'1'}]);
    setShowResForm(true);
  };
  const openEditClientRes = (g) => {
    setEditRes(g);
    setResClient({
      client_name: g.client_name, client_phone: g.phone||'',
      payment_status: g.allPago?'Pago':g.allPendente?'Pendente':'Parcial',
      paid_amount: String(g.totalPaid||''), notes: g.notes||''
    });
    setResItems(g.items.map(r=>({presale_product_id:String(r.presale_product_id),qty:String(r.qty),_id:r.id})));
    setShowResForm(true);
  };
  const addItem = () => setResItems([...resItems,{presale_product_id:'',qty:'1'}]);
  const removeItem = (idx) => { if(resItems.length<=1) return; setResItems(resItems.filter((_,i)=>i!==idx)); };
  const updateItem = (idx,field,value) => { const c=[...resItems]; c[idx]={...c[idx],[field]:value}; setResItems(c); };

  const saveRes = async () => {
    if (!resClient.client_name) return alert('Preencha o nome do cliente');
    const validItems = resItems.filter(it=>it.presale_product_id&&parseInt(it.qty)>0);
    if (!validItems.length) return alert('Adicione pelo menos um produto');
    try {
      if (editRes && editRes.items) {
        for (const old of editRes.items) await api.deletePresaleReservation(old.id);
      }
      for (const it of validItems) {
        await api.createPresaleReservation({
          presale_product_id:parseInt(it.presale_product_id), client_name:resClient.client_name,
          client_phone:resClient.client_phone, qty:parseInt(it.qty),
          payment_status:resClient.payment_status, paid_amount:parseFloat(resClient.paid_amount)||0, notes:resClient.notes
        });
      }
      setShowResForm(false); load();
    } catch(e){alert(e.message);}
  };

  const delClientRes = async(g)=>{ if(!window.confirm('Excluir TODAS as reservas de '+g.client_name+'?')) return; for(const r of g.items) await api.deletePresaleReservation(r.id); load(); };

  const toggleDelivered = async (id) => {
    try { await api.togglePresaleDelivered(id); load(); } catch(e) { alert(e.message); }
  };

  const downloadReceipt = async(n)=>{ try{await api.presaleReceipt(n);}catch(e){alert('Erro ao gerar PDF: '+e.message);} };

  // Group by client
  const groupByClient = (list) => {
    const map = {};
    list.forEach(r => {
      if (!map[r.client_name]) map[r.client_name] = {client_name:r.client_name,phone:'',items:[],total:0,totalPaid:0,notes:'',allPago:true,allPendente:true};
      const g = map[r.client_name];
      g.items.push(r);
      g.total += parseFloat(r.total_value||0);
      if (r.payment_status==='Pago') g.totalPaid += parseFloat(r.total_value||0);
      else if (r.payment_status==='Parcial') g.totalPaid += parseFloat(r.paid_amount||0);
      if (r.payment_status!=='Pago') g.allPago = false;
      if (r.payment_status!=='Pendente') g.allPendente = false;
      if (r.notes && !g.notes) g.notes = r.notes;
      if (r.client_phone && !g.phone) g.phone = r.client_phone;
    });
    return Object.values(map).sort((a,b)=>a.client_name.localeCompare(b.client_name));
  };

  const filteredRes = reservations.filter(r => {
    if (filterProduct && String(r.presale_product_id)!==filterProduct) return false;
    if (filterStatus && r.payment_status!==filterStatus) return false;
    return true;
  });
  const clientGroups = groupByClient(filteredRes);

  const calcFormTotal = () => resItems.reduce((sum,it)=>{
    const p=products.find(pr=>pr.id===parseInt(it.presale_product_id));
    return p?sum+(parseInt(it.qty)||0)*parseFloat(p.price):sum;
  },0);

  const S = {
    page:{padding:'20px',maxWidth:1200,margin:'0 auto'},
    header:{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20,flexWrap:'wrap',gap:10},
    title:{fontSize:22,fontWeight:700,color:'var(--text-primary,#fff)'},
    tabs:{display:'flex',gap:4,background:'var(--bg-secondary,#1e1e2e)',borderRadius:8,padding:4},
    tab:(a)=>({padding:'8px 18px',borderRadius:6,border:'none',cursor:'pointer',fontWeight:600,fontSize:13,background:a?'var(--accent,#7c3aed)':'transparent',color:a?'#fff':'var(--text-secondary,#aaa)',transition:'all 0.2s'}),
    card:{background:'var(--bg-secondary,#1e1e2e)',borderRadius:12,padding:20,marginBottom:16},
    kpiRow:{display:'flex',gap:12,marginBottom:16,flexWrap:'wrap'},
    kpi:(c)=>({flex:'1 1 140px',background:'var(--bg-secondary,#1e1e2e)',borderRadius:12,padding:'16px 20px',borderLeft:'4px solid '+c,minWidth:140}),
    kpiLabel:{fontSize:11,color:'var(--text-secondary,#aaa)',textTransform:'uppercase',letterSpacing:1,marginBottom:4},
    kpiVal:{fontSize:22,fontWeight:700,color:'var(--text-primary,#fff)'},
    kpiSub:{fontSize:12,color:'var(--text-secondary,#aaa)',marginTop:2},
    table:{width:'100%',borderCollapse:'collapse'},
    th:{textAlign:'left',padding:'10px 12px',fontSize:12,color:'var(--text-secondary,#aaa)',borderBottom:'1px solid var(--border,#333)',textTransform:'uppercase',letterSpacing:0.5},
    td:{padding:'10px 12px',fontSize:14,color:'var(--text-primary,#fff)',borderBottom:'1px solid var(--border,#222)'},
    btn:(bg)=>({padding:'8px 16px',borderRadius:8,border:'none',cursor:'pointer',fontWeight:600,fontSize:13,background:bg||'var(--accent,#7c3aed)',color:'#fff',transition:'opacity 0.2s'}),
    btnSm:(bg)=>({padding:'4px 10px',borderRadius:6,border:'none',cursor:'pointer',fontWeight:600,fontSize:12,background:bg||'var(--accent,#7c3aed)',color:'#fff',marginRight:4}),
    badge:(s)=>({display:'inline-block',padding:'3px 10px',borderRadius:20,fontSize:11,fontWeight:700,
      background:s==='Pago'?'#065f46':s==='Parcial'?'#78350f':s==='Entregue'?'#1e3a5f':'#7f1d1d',
      color:s==='Pago'?'#6ee7b7':s==='Parcial'?'#fbbf24':s==='Entregue'?'#93c5fd':'#fca5a5'}),
    progressBar:{height:8,borderRadius:4,background:'var(--border,#333)',overflow:'hidden',marginTop:6},
    progressFill:(pct,c)=>({height:'100%',width:pct+'%',borderRadius:4,background:c,transition:'width 0.4s'}),
    overlay:{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000},
    modal:{background:'var(--bg-primary,#121218)',borderRadius:16,padding:24,width:'90%',maxWidth:520,maxHeight:'90vh',overflow:'auto'},
    modalTitle:{fontSize:18,fontWeight:700,color:'var(--text-primary,#fff)',marginBottom:16},
    input:{width:'100%',padding:'10px 12px',borderRadius:8,border:'1px solid var(--border,#333)',background:'var(--bg-secondary,#1e1e2e)',color:'var(--text-primary,#fff)',fontSize:14,marginBottom:10,boxSizing:'border-box'},
    select:{width:'100%',padding:'10px 12px',borderRadius:8,border:'1px solid var(--border,#333)',background:'var(--bg-secondary,#1e1e2e)',color:'var(--text-primary,#fff)',fontSize:14,marginBottom:10,boxSizing:'border-box'},
    label:{fontSize:12,fontWeight:600,color:'var(--text-secondary,#aaa)',marginBottom:4,display:'block'},
    filterRow:{display:'flex',gap:8,marginBottom:12,flexWrap:'wrap',alignItems:'center'},
    clientCard:{background:'var(--bg-secondary,#1e1e2e)',borderRadius:12,padding:16,marginBottom:12},
    clientHeader:{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10,flexWrap:'wrap',gap:8},
    clientName:{fontWeight:700,color:'var(--text-primary,#fff)',fontSize:15},
    clientPhone:{fontSize:12,color:'var(--text-secondary,#aaa)'},
    clientActions:{display:'flex',gap:4,flexWrap:'wrap'},
    itemLine:(delivered)=>({display:'flex',justifyContent:'space-between',alignItems:'center',padding:'8px 0',borderBottom:'1px solid var(--border,#222)',fontSize:13,
      opacity:delivered?0.5:1, textDecoration:delivered?'line-through':'none'}),
    clientFooter:{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:10,paddingTop:10,borderTop:'1px solid var(--border,#333)'},
    deliverBtn:(delivered)=>({padding:'3px 8px',borderRadius:6,border:'none',cursor:'pointer',fontWeight:600,fontSize:11,
      background:delivered?'#1e3a5f':'#374151', color:delivered?'#93c5fd':'#9ca3af', marginLeft:6}),
  };

  if (loading && !summary) return <div style={S.page}><p style={{color:'var(--text-secondary,#aaa)'}}>Carregando pre-venda...</p></div>;
  const sm = summary || {totalProducts:0,totalUnits:0,totalReserved:0,totalAvailable:0,totalPaid:0,totalPending:0,totalPartialRemaining:0,totalValue:0};

  return (
    <div style={S.page}>
      <div style={S.header}>
        <div style={S.title}>Pre-Venda</div>
        <div style={S.tabs}>
          {isAdmin && <button style={S.tab(tab==='resumo')} onClick={()=>setTab('resumo')}>Resumo</button>}
          {isAdmin && <button style={S.tab(tab==='produtos')} onClick={()=>setTab('produtos')}>Produtos</button>}
          <button style={S.tab(tab==='reservas')} onClick={()=>setTab('reservas')}>Reservas</button>
        </div>
      </div>

      {/* ── RESUMO ── */}
      {tab === 'resumo' && isAdmin && <>
        <div style={S.kpiRow}>
          <div style={S.kpi('#7c3aed')}><div style={S.kpiLabel}>Produtos</div><div style={S.kpiVal}>{sm.totalProducts}</div></div>
          <div style={S.kpi('#3b82f6')}><div style={S.kpiLabel}>Unidades Totais</div><div style={S.kpiVal}>{sm.totalUnits}</div><div style={S.kpiSub}>{sm.totalReserved} reservadas / {sm.totalAvailable} disponiveis</div></div>
          <div style={S.kpi('#10b981')}><div style={S.kpiLabel}>Ja Recebido</div><div style={S.kpiVal}>{fmt(sm.totalPaid)}</div></div>
          <div style={S.kpi('#f59e0b')}><div style={S.kpiLabel}>A Receber</div><div style={S.kpiVal}>{fmt((Number(sm.totalPending)||0) + (Number(sm.totalPartialRemaining)||0))}</div><div style={S.kpiSub}>{fmt(sm.totalPending)} pendente / {fmt(sm.totalPartialRemaining)} restante parcial</div></div>
        </div>
        <div style={S.card}>
          <div style={{fontSize:15,fontWeight:700,color:'var(--text-primary,#fff)',marginBottom:14}}>Produtos em Pre-Venda</div>
          <table style={S.table}><thead><tr>
            <th style={S.th}>Produto</th><th style={{...S.th,textAlign:'center'}}>Total</th><th style={{...S.th,textAlign:'center'}}>Reservado</th><th style={{...S.th,textAlign:'center'}}>Disponivel</th><th style={{...S.th,textAlign:'right'}}>Valor Reservado</th><th style={{...S.th,width:120}}></th>
          </tr></thead><tbody>
            {products.map(p => {
              const pct=p.total_qty>0?Math.round((p.reserved_qty/p.total_qty)*100):0;
              const pVal=reservations.filter(r=>r.presale_product_id===p.id).reduce((s,r)=>s+parseFloat(r.total_value||0),0);
              return (<tr key={p.id}>
                <td style={S.td}><div style={{fontWeight:600}}>{p.name}</div><div style={{fontSize:12,color:'var(--text-secondary,#aaa)'}}>{fmt(p.price)} / un</div><div style={S.progressBar}><div style={S.progressFill(pct,pct>=100?'#ef4444':pct>=75?'#f59e0b':'#7c3aed')}/></div></td>
                <td style={{...S.td,textAlign:'center',fontWeight:700}}>{p.total_qty}</td>
                <td style={{...S.td,textAlign:'center',fontWeight:700,color:pct>=100?'#ef4444':'#f59e0b'}}>{p.reserved_qty}</td>
                <td style={{...S.td,textAlign:'center',fontWeight:700,color:p.remaining_qty>0?'#10b981':'#ef4444'}}>{p.remaining_qty}{p.remaining_qty<=0&&<span style={{...S.badge('Pendente'),marginLeft:6,background:'#7f1d1d',color:'#fca5a5'}}>ESGOTADO</span>}</td>
                <td style={{...S.td,textAlign:'right',fontWeight:600}}>{fmt(pVal)}</td>
                <td style={{...S.td,textAlign:'right'}}>{p.remaining_qty>0&&<button style={S.btnSm('#10b981')} onClick={()=>openNewRes(p.id)}>+ Reserva</button>}</td>
              </tr>);
            })}
            {products.length===0&&<tr><td colSpan={6} style={{...S.td,textAlign:'center',color:'var(--text-secondary,#aaa)'}}>Nenhum produto cadastrado</td></tr>}
          </tbody></table>
        </div>
        <div style={S.card}>
          <div style={{fontSize:15,fontWeight:700,color:'var(--text-primary,#fff)',marginBottom:14}}>Reservas por Cliente</div>
          {(()=>{
            const allGroups=groupByClient(reservations);
            if(!allGroups.length) return <p style={{color:'var(--text-secondary,#aaa)',fontSize:14}}>Nenhuma reserva registrada</p>;
            return allGroups.map(g=>(
              <div key={g.client_name} style={{marginBottom:12,padding:'10px 14px',background:'var(--bg-primary,#121218)',borderRadius:8}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:6}}>
                  <div style={{display:'flex',alignItems:'center',gap:8}}>
                    <span style={{fontWeight:700,color:'var(--text-primary,#fff)',fontSize:14}}>{g.client_name}</span>
                    <button style={{padding:'3px 10px',borderRadius:6,border:'none',cursor:'pointer',background:'#7c3aed',color:'#fff',fontWeight:600,fontSize:11}} onClick={()=>downloadReceipt(g.client_name)}>PDF</button>
                    {g.phone&&<button style={{padding:'3px 10px',borderRadius:6,border:'none',cursor:'pointer',background:'#25d366',color:'#fff',fontWeight:600,fontSize:11}} onClick={()=>openWpp(g.phone)}>WhatsApp</button>}
                  </div>
                  <div style={{textAlign:'right'}}>
                    <div style={{fontWeight:600,color:'var(--text-secondary,#aaa)',fontSize:13}}>{fmt(g.total)}</div>
                    {g.totalPaid>0&&<div style={{fontSize:11,color:'#6ee7b7'}}>Pago: {fmt(g.totalPaid)}</div>}
                  </div>
                </div>
                {g.items.map(r=>(<div key={r.id} style={{display:'flex',justifyContent:'space-between',alignItems:'center',fontSize:13,color:'var(--text-secondary,#aaa)',padding:'3px 0',opacity:r.delivered?0.5:1}}>
                  <span style={{textDecoration:r.delivered?'line-through':'none'}}>{r.qty}x {r.product_name}</span>
                  <div style={{display:'flex',alignItems:'center',gap:6}}>
                    <span>{fmt(r.total_value)}</span>
                    {r.payment_status==='Parcial'&&<span style={{fontSize:11,color:'#fbbf24'}}>(pago {fmt(r.paid_amount)})</span>}
                    <span style={S.badge(r.payment_status)}>{r.payment_status}</span>
                    {r.delivered&&<span style={S.badge('Entregue')}>Entregue</span>}
                  </div>
                </div>))}
              </div>
            ));
          })()}
        </div>
      </>}

      {/* ── PRODUTOS ── */}
      {tab === 'produtos' && isAdmin && <>
        <div style={{display:'flex',justifyContent:'flex-end',marginBottom:12}}><button style={S.btn()} onClick={openNewProd}>+ Novo Produto</button></div>
        <div style={S.card}>
          <table style={S.table}><thead><tr>
            <th style={S.th}>Produto</th><th style={{...S.th,textAlign:'center'}}>Preco</th><th style={{...S.th,textAlign:'center'}}>Total</th><th style={{...S.th,textAlign:'center'}}>Reservado</th><th style={{...S.th,textAlign:'center'}}>Disponivel</th><th style={{...S.th,textAlign:'center'}}>Status</th><th style={{...S.th,textAlign:'right'}}>Acoes</th>
          </tr></thead><tbody>
            {products.map(p=>(<tr key={p.id}>
              <td style={{...S.td,fontWeight:600}}>{p.name}</td>
              <td style={{...S.td,textAlign:'center'}}>{fmt(p.price)}</td>
              <td style={{...S.td,textAlign:'center'}}>{p.total_qty}</td>
              <td style={{...S.td,textAlign:'center',fontWeight:700,color:'#f59e0b'}}>{p.reserved_qty}</td>
              <td style={{...S.td,textAlign:'center',fontWeight:700,color:p.remaining_qty>0?'#10b981':'#ef4444'}}>{p.remaining_qty}</td>
              <td style={{...S.td,textAlign:'center'}}><span style={S.badge(p.remaining_qty>0?'Pago':'Pendente')}>{p.remaining_qty>0?'Disponivel':'Esgotado'}</span></td>
              <td style={{...S.td,textAlign:'right'}}>
                {p.remaining_qty>0&&<button style={S.btnSm('#10b981')} onClick={()=>openNewRes(p.id)}>Reservar</button>}
                <button style={S.btnSm('#3b82f6')} onClick={()=>openEditProd(p)}>Editar</button>
                <button style={S.btnSm('#ef4444')} onClick={()=>delProd(p.id)}>Excluir</button>
              </td>
            </tr>))}
            {products.length===0&&<tr><td colSpan={7} style={{...S.td,textAlign:'center',color:'var(--text-secondary,#aaa)'}}>Nenhum produto cadastrado</td></tr>}
          </tbody></table>
        </div>
      </>}

      {/* ── RESERVAS (grouped by client) ── */}
      {tab === 'reservas' && <>
        <div style={{display:'flex',justifyContent:'space-between',marginBottom:12,flexWrap:'wrap',gap:8}}>
          <div style={S.filterRow}>
            <select style={{...S.select,width:'auto',marginBottom:0}} value={filterProduct} onChange={e=>setFilterProduct(e.target.value)}>
              <option value="">Todos os produtos</option>
              {products.map(p=><option key={p.id} value={String(p.id)}>{p.name}</option>)}
            </select>
            <select style={{...S.select,width:'auto',marginBottom:0}} value={filterStatus} onChange={e=>setFilterStatus(e.target.value)}>
              <option value="">Todos os status</option>
              <option value="Pendente">Pendente</option>
              <option value="Pago">Pago</option>
              <option value="Parcial">Parcial</option>
            </select>
          </div>
          <button style={S.btn()} onClick={()=>openNewRes('')}>+ Nova Reserva</button>
        </div>

        {clientGroups.length===0 && <div style={S.card}><p style={{color:'var(--text-secondary,#aaa)',textAlign:'center',margin:0}}>Nenhuma reserva encontrada</p></div>}

        {clientGroups.map(g => {
          const status = g.allPago?'Pago':g.allPendente?'Pendente':'Parcial';
          const allDelivered = g.items.every(r=>r.delivered);
          const someDelivered = g.items.some(r=>r.delivered);
          return (
            <div key={g.client_name} style={{...S.clientCard, border: allDelivered ? '1px solid #1e3a5f' : 'none'}}>
              <div style={S.clientHeader}>
                <div>
                  <div style={{display:'flex',alignItems:'center',gap:8}}>
                    <span style={S.clientName}>{g.client_name}</span>
                    {allDelivered && <span style={S.badge('Entregue')}>Tudo entregue</span>}
                    {someDelivered && !allDelivered && <span style={{...S.badge('Entregue'),opacity:0.6}}>Entrega parcial</span>}
                  </div>
                  {g.phone && <div style={S.clientPhone}>{g.phone}</div>}
                </div>
                <div style={S.clientActions}>
                  {g.phone && <button style={S.btnSm('#25d366')} onClick={()=>openWpp(g.phone)}>WhatsApp</button>}
                  <button style={S.btnSm('#7c3aed')} onClick={()=>downloadReceipt(g.client_name)}>PDF</button>
                  <button style={S.btnSm('#3b82f6')} onClick={()=>openEditClientRes(g)}>Editar</button>
                  <button style={S.btnSm('#ef4444')} onClick={()=>delClientRes(g)}>Excluir</button>
                </div>
              </div>

              {g.items.map(r => (
                <div key={r.id} style={S.itemLine(r.delivered)}>
                  <span style={{color:'var(--text-primary,#fff)',textDecoration:r.delivered?'line-through':'none'}}>
                    {r.qty}x {r.product_name}
                  </span>
                  <div style={{display:'flex',alignItems:'center',gap:6}}>
                    <span style={{fontWeight:600,textDecoration:'none'}}>{fmt(r.total_value)}</span>
                    <button style={S.deliverBtn(r.delivered)} onClick={()=>toggleDelivered(r.id)}>
                      {r.delivered ? '✓ Entregue' : 'Entregar'}
                    </button>
                  </div>
                </div>
              ))}

              <div style={S.clientFooter}>
                <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
                  <span style={S.badge(status)}>{status}</span>
                  {status==='Parcial'&&<span style={{fontSize:12,color:'#fbbf24'}}>Pago: {fmt(g.totalPaid)}</span>}
                  {g.notes&&<span style={{fontSize:12,color:'var(--text-secondary,#aaa)',fontStyle:'italic'}}>"{g.notes}"</span>}
                </div>
                <div style={{fontSize:16,fontWeight:700,color:'var(--text-primary,#fff)'}}>{fmt(g.total)}</div>
              </div>
            </div>
          );
        })}
      </>}

      {/* ── MODAL: PRODUTO ── */}
      {showProdForm && (<div style={S.overlay} onClick={()=>setShowProdForm(false)}><div style={S.modal} onClick={e=>e.stopPropagation()}>
        <div style={S.modalTitle}>{editProd?'Editar Produto':'Novo Produto Pre-Venda'}</div>
        <label style={S.label}>Nome do Produto</label>
        <input style={S.input} value={prodForm.name} onChange={e=>setProdForm({...prodForm,name:e.target.value})} placeholder="Ex: Blister Duplo Celebracao 30 Anos" autoFocus />
        <label style={S.label}>Preco de Venda (R$)</label>
        <input style={S.input} type="number" step="0.01" value={prodForm.price} onChange={e=>setProdForm({...prodForm,price:e.target.value})} placeholder="84.00" />
        <label style={S.label}>Quantidade Total Disponivel</label>
        <input style={S.input} type="number" value={prodForm.total_qty} onChange={e=>setProdForm({...prodForm,total_qty:e.target.value})} placeholder="60" />
        <div style={{display:'flex',gap:8,marginTop:8}}>
          <button style={S.btn()} onClick={saveProd}>{editProd?'Salvar':'Cadastrar'}</button>
          <button style={S.btn('#666')} onClick={()=>setShowProdForm(false)}>Cancelar</button>
        </div>
      </div></div>)}

      {/* ── MODAL: RESERVA ── */}
      {showResForm && (<div style={S.overlay} onClick={()=>setShowResForm(false)}><div style={S.modal} onClick={e=>e.stopPropagation()}>
        <div style={S.modalTitle}>{editRes?'Editar Reserva':'Nova Reserva'}</div>
        <label style={S.label}>Nome do Cliente</label>
        <input style={S.input} value={resClient.client_name} onChange={e=>setResClient({...resClient,client_name:e.target.value})} placeholder="Nome completo" autoFocus />
        <label style={S.label}>Telefone / Contato</label>
        <input style={S.input} value={resClient.client_phone} onChange={e=>setResClient({...resClient,client_phone:e.target.value})} placeholder="(32) 99999-9999" />
        <div style={{marginBottom:6,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <label style={{...S.label,marginBottom:0}}>Produtos</label>
          <button style={S.btnSm('#10b981')} onClick={addItem}>+ Produto</button>
        </div>
        {resItems.map((it,idx)=>{
          const sel=products.find(pr=>pr.id===parseInt(it.presale_product_id));
          const lt=sel?(parseInt(it.qty)||0)*parseFloat(sel.price):0;
          return (<div key={idx} style={{display:'flex',gap:8,alignItems:'flex-end',marginBottom:8}}>
            <div style={{flex:1}}>
              <select style={{...S.select,marginBottom:0}} value={it.presale_product_id} onChange={e=>updateItem(idx,'presale_product_id',e.target.value)}>
                <option value="">Selecione</option>
                {products.map(p=>(<option key={p.id} value={String(p.id)} disabled={p.remaining_qty<=0}>{p.name} ({p.remaining_qty} disp.) - {fmt(p.price)}</option>))}
              </select>
            </div>
            <div style={{width:70}}><input style={{...S.input,marginBottom:0,textAlign:'center'}} type="number" min="1" value={it.qty} onChange={e=>updateItem(idx,'qty',e.target.value)} /></div>
            <div style={{width:90,textAlign:'right',fontSize:13,fontWeight:600,color:'var(--text-primary,#fff)',paddingBottom:12}}>{fmt(lt)}</div>
            {resItems.length>1&&<button style={{padding:'8px',borderRadius:6,border:'none',cursor:'pointer',background:'#7f1d1d',color:'#fca5a5',fontWeight:700,fontSize:14,marginBottom:10,lineHeight:'1'}} onClick={()=>removeItem(idx)}>X</button>}
          </div>);
        })}
        <div style={{textAlign:'right',padding:'8px 0',fontSize:15,fontWeight:700,color:'var(--text-primary,#fff)',borderTop:'1px solid var(--border,#333)',marginTop:8}}>Total: {fmt(calcFormTotal())}</div>
        <label style={S.label}>Status do Pagamento</label>
        <select style={S.select} value={resClient.payment_status} onChange={e=>setResClient({...resClient,payment_status:e.target.value})}>
          <option value="Pendente">Pendente</option><option value="Pago">Pago</option><option value="Parcial">Parcial</option>
        </select>
        {resClient.payment_status==='Parcial'&&<>
          <label style={S.label}>Valor Ja Pago (R$)</label>
          <input style={S.input} type="number" step="0.01" value={resClient.paid_amount} onChange={e=>setResClient({...resClient,paid_amount:e.target.value})} placeholder="Ex: 50.00" />
          <div style={{fontSize:12,color:'#fbbf24',marginBottom:10,marginTop:-6}}>Restante: {fmt(calcFormTotal()-(parseFloat(resClient.paid_amount)||0))}</div>
        </>}
        <label style={S.label}>Observacoes</label>
        <textarea style={{...S.input,minHeight:60,resize:'vertical'}} value={resClient.notes} onChange={e=>setResClient({...resClient,notes:e.target.value})} placeholder="Ex: Vai buscar no evento, pix parcial de R$50" />
        <div style={{display:'flex',gap:8,marginTop:8}}>
          <button style={S.btn()} onClick={saveRes}>{editRes?'Salvar':'Registrar Reserva'}</button>
          <button style={S.btn('#666')} onClick={()=>setShowResForm(false)}>Cancelar</button>
        </div>
      </div></div>)}
    </div>
  );
}
